import { FC, useEffect } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import ConfirmSchedule from "./ConfirmSchedule";
import useSchedule from "hooks/use-schedule";
import TableGrid from "components/Table";
import LoadingComponent from "components/Main/Loading";

interface DrawerExemploProps {
  isOpen: boolean;
  fecharDrawer: () => void;
  id: number;
}

const DrawerSchedule: FC<DrawerExemploProps> = ({
  isOpen,
  fecharDrawer,
  id,
}) => {
  const {
    getScheduleById,
    scheduleSelect,
    headers,
    idSelectDate,
    setSelectIdDate,
    loadingDrawer,
    datesSchedulesModify,
    saveReSchedulePatch,
  } = useSchedule();
  const bgLoading = useColorModeValue("white", "#111C44");
  const colorClose = useColorModeValue("black", "white");
  const colorSchemeButton = useColorModeValue("green", "white");
  // useEffect(() => {
  //   if (scheduleSelect.length === 0) {
  //     if (id !== 0) {
  //       getScheduleById(id);
  //     }
  //   }
  // });

  useEffect(() => {
    if (isOpen) {
      setSelectIdDate(0);
      getScheduleById(id);
    }
  }, [getScheduleById, id, isOpen, setSelectIdDate]);

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={fecharDrawer}
      closeOnOverlayClick={false}
      size={"md"}
    >
      <DrawerOverlay />
      <DrawerContent bg={bgLoading}>
        <DrawerCloseButton color={colorClose} />
        <DrawerBody mt={20} bg={bgLoading}>
          <VStack spacing={4}>
            <HStack spacing={4}>
              <ConfirmSchedule id={idSelectDate} />
              <Button
                colorScheme={colorSchemeButton}
                onClick={saveReSchedulePatch}
                variant={datesSchedulesModify.length > 0 ? "solid" : "outline"}
                isDisabled={datesSchedulesModify.length < 1}
              >
                Salvar
              </Button>
            </HStack>
            {loadingDrawer ? (
              <>
                <Box bg={bgLoading}>
                  <LoadingComponent />
                </Box>
              </>
            ) : (
              <>
                <TableGrid
                  id="schedule-drawer"
                  headers={headers}
                  data={scheduleSelect}
                  itsSortable={true}
                  entity="schedule-drawer"
                  height={"420px"}
                />
              </>
            )}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerSchedule;
